var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 2,
    transform: "matrix(0 -1 -1 0 20 20)",
    fill: "#D1DBCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9996 10.5918L12.9496 7.64182C13.1057 7.48661 13.3169 7.39949 13.5371 7.39949C13.7573 7.39949 13.9685 7.48661 14.1246 7.64182C14.2027 7.71928 14.2647 7.81145 14.307 7.913C14.3493 8.01455 14.3711 8.12347 14.3711 8.23348C14.3711 8.34349 14.3493 8.45241 14.307 8.55396C14.2647 8.65551 14.2027 8.74768 14.1246 8.82515L10.5913 12.3585C10.5138 12.4366 10.4216 12.4986 10.3201 12.5409C10.2185 12.5832 10.1096 12.605 9.9996 12.605C9.88959 12.605 9.78066 12.5832 9.67912 12.5409C9.57757 12.4986 9.4854 12.4366 9.40793 12.3585L5.83293 8.82515C5.7557 8.74728 5.69459 8.65494 5.65312 8.5534C5.61165 8.45187 5.59063 8.34315 5.59126 8.23348C5.59063 8.12381 5.61165 8.01509 5.65312 7.91356C5.69459 7.81203 5.7557 7.71968 5.83293 7.64182C5.98907 7.48661 6.20027 7.39949 6.42043 7.39949C6.64058 7.39949 6.85179 7.48661 7.00793 7.64182L9.9996 10.5918Z",
    fill: "#2D5B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.c3f8b491ae50c432f9ca16d107d2e76f.svg";
export { ForwardRef as ReactComponent };